'use strict';

function _I18nRenderer (options) {
	this.options = options;
}

_I18nRenderer.prototype.setArguments = function(value) {
	var _arguments = this.options.arguments,
		splitter = ',';

	// if value === --empty--
	// return empty string, otherwise regular behaviour
	// SUNRISEDIG-4154
	if (value === '--empty--'){
		value = '';
	} else {
		if (!(_arguments instanceof Array)) {
			if (typeof(_arguments) === 'number') {
				_arguments = _arguments.toString();
			}

			if (typeof(_arguments) !== 'string') {
				return value;
			}

			if (typeof(this.options.argumentsSplitter) === 'string') {
				splitter = this.options.argumentsSplitter;
			}
			// Prevent splitting string with comma by using argumentsSplitter = false
			if (this.options.argumentsSplitter !== false) {
				_arguments = _arguments.split(splitter);
			} else {
				_arguments = [_arguments];
			}
		}

		$.each(_arguments, function (index, argument) {
			value = value.replace('{'+index+'}', argument);
		});
	}

	return value;
};

_I18nRenderer.prototype.render = function() {

	var code = this.options.code,
		i18n;

	if (ReactApp.Env && ReactApp.Env.debug && ReactApp.DebugI18n) {
		return this.setArguments('Key: ' + code);
	}

	if (typeof(code) !== 'string') {
		if (typeof(console) === 'object') {
			if (ReactApp.Env.debug) {
				/*eslint-disable */
				console.error('I18n: prop code required (code="#code#")');
				/*eslint-enable */
			}
		}
	}

	if (typeof(window.ReactAppI18n) !== 'object') {
		if (typeof(console) === 'object') {
			if (ReactApp.Env.debug) {
				/*eslint-disable */
				console.log('I18n: no property file found for code: '+code);
				/*eslint-enable */
			}
		}
		return code;
	}

	i18n = window.ReactAppI18n[code];

	if (typeof(i18n) !== 'string') {
		if (typeof(console) === 'object') {
			if (ReactApp.Env.debug) {
				/*eslint-disable */
				console.error('I18n: no key "'+code+'" found!');
				/*eslint-enable */
			}
		}
		return code;
	}

	i18n = this.setArguments(i18n);

	return i18n;
};

module.exports = _I18nRenderer;



// WEBPACK FOOTER //
// ./src/components/utils/helper/helper-i18n-renderer.js